import apolloClient from 'api/apolloClient';
import { CREATE_GROUP, GROUP_BY_ID, UPDATE_GROUP } from 'api/groupService';
import { makeAutoObservable, runInAction } from 'mobx';
import { AssigneeType, Group, GroupSource, InputGroup } from 'types/groupService';
import { ApolloQueryResult } from '@apollo/client';

export const INITIAL_GROUP_OBJECT: Group = Object.freeze({
  id: '',
  name: '',
  source: GroupSource.ESTORE,
  browsingCriteria: {
    effectiveDate: '',
    zipCode: '',
    state: '',
    county: '',
  },
  contactInfo: {
    firstName: '',
    lastName: '',
    primaryEmail: '',
    title: '',
    primaryPhone: '',
    primaryAddress: {
      city: '',
      street: '',
      street2: '',
      zip: '',
      state: '',
      county: '',
    },
  },
  creationDateTime: '',
  assigned: [],
  agentOfRecord: {
    id: '',
    name: '',
    npn: '',
    email: '',
    type: AssigneeType.AGENT,
  },
  lastUpdateTime: '',
  notes: '',
  archived: false,
  additionalAORs: [],
});

export class GroupStore {
  group: Group = {
    ...INITIAL_GROUP_OBJECT,
  };

  async createGroup(inputGroup: InputGroup): Promise<void> {
    const res = await apolloClient.mutate<{ createEStoreGroup: Group }>({
      mutation: CREATE_GROUP,
      variables: { inputGroup },
      fetchPolicy: 'no-cache',
    });
    runInAction(() => {
      if (res.data) {
        this.group = res.data.createEStoreGroup;
      }
    });
  }

  async getGroupById(id: string): Promise<void> {
    const res = await apolloClient.query<{ groupById: Group }>({
      query: GROUP_BY_ID,
      variables: { id },
      fetchPolicy: 'no-cache',
    });
    runInAction(() => {
      this.group = res.data.groupById;
    });
  }

  // eslint-disable-next-line class-methods-use-this
  async getGroupByIdCached(id: string): Promise<ApolloQueryResult<{ groupById: Group }>> {
    return apolloClient.query<{ groupById: Group }>({
      query: GROUP_BY_ID,
      variables: { id },
      fetchPolicy: 'cache-first',
    });
  }

  // eslint-disable-next-line class-methods-use-this
  async updateGroup(inputGroup: InputGroup, sponsorId: string, cartId: string, isEnrollNow = false): Promise<boolean> {
    const res = await apolloClient.mutate<{ updateGroup: Group; contactMe: boolean }>({
      mutation: UPDATE_GROUP,
      variables: { inputGroup, sponsorId, groupId: inputGroup.id, cartId, isEnrollNow },
    });
    runInAction(() => {
      if (res.data) {
        this.group = res.data.updateGroup;
      }
    });
    return res.data?.contactMe || false;
  }

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }
}
